import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Config } from '../../config/config';

@Injectable({
  providedIn: 'root'
})
export class LeituraService {

  private _config: Config = new Config();

  constructor(private http: HttpClient) { }

  /**
   *
   * @param filtros
   * @param page
   * @param perPage
   */
  public listar(filtros: object = null, page: number|string = 1, perPage: number|string = null): Observable<any> {
    perPage = perPage == undefined ? '' : perPage;
    let params = new HttpParams();
    params = params.append('page', page.toString());
    params = params.append('arquivos', "0");
    if (filtros != null) {
        Object.keys(filtros).forEach(filter => {
            if (Array.isArray(filtros[filter])) {
                filtros[filter].forEach((value, key) => {
                    params = params.append(`${filter}[${key}]`, value);
                });
            } else {
                params = params.append(filter, filtros[filter]);
            }
        });
    }
    return this.http.get<any>(`${this._config.get('urlServiceBackend')}notificacao/leitura/listar${perPage != null ? '/' + perPage : ''}`, {
        params: params
    });
  }

  public getArquivoEmail(idArquivoEmail): Observable<any> {
    return this.http.post<any>(`${this._config.get('urlServiceBackend')}notificacao/leitura/arquivo/pdf/baixar`, {
      id: idArquivoEmail
    });
  }

  /**
  * Atualização de dads do arquivo
  * @param idPdf
  * @param data
  */
  public updateArquivo(idPdf, data): Observable<any> {
      return this.http.post<any>(`${this._config.get('urlServiceBackend')}notificacao/leitura/arquivo/${idPdf}/atualizar`, data)
  }
}
